<ng-container *ngIf="actualContractFormName$ | async as actualContractFormName">
  <div>
    <label>Form Name</label>
    <span>{{ actualContractFormName.ActualContractFormName }}</span>
  </div>
</ng-container>
